import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../service/api.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-resultadoautoavaliacao',
  templateUrl: './resultadoautoavaliacao.component.html',
  styleUrls: ['./resultadoautoavaliacao.component.css']
})
export class ResultadoautoavaliacaoComponent implements OnInit {
  idempresa: string;
  jsonArrayDescricao: any;
  acertou: number = 0;
  errou: number = 0;
  mediaacerto: string = '';

  constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.idempresa = params['id'];
    });
    this.carregarLista();
  }

  carregarLista(){
    this.jsonArrayDescricao = [];
    this.spinner.show();
    this.apiService.getListagemId('listarresultadoautoavaliacao', this.idempresa)
      .subscribe(
        (data) => {
          this.jsonArrayDescricao = data;
          this.spinner.hide();

          for (let i in this.jsonArrayDescricao) {
            if (this.jsonArrayDescricao[i]['notavalor'] !== '0') {
              this.acertou += 1;
            }

            if (this.jsonArrayDescricao[i]['notavalor'] === '0') {
              this.errou += 1;
            }
          }

          var media = (this.acertou / this.jsonArrayDescricao.length) * 100;
          this.mediaacerto = media.toFixed(2);
        },
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)));
          },
        () => {
          this.spinner.hide();
          console.log('all data gets');
        }
      );
  }

}
